<template>
    <div>
        <dx-check-box
            class="m-3"
            :value="checkboxRef"
            @value-changed="onValueChange"
            text="Строки с кодом фин.сист."
        ></dx-check-box>
        <dx-check-box
            class="m-3"
            :value="showDeleteRef"
            @value-changed="onShowDeleteValueChange"
            text="В т.ч. удаленные"
        ></dx-check-box>
    </div>
    <ai-tree-list-edit-wrapper
        :meta="meta"
        :args="args"
        ref="treeListRef"
        @treeListEditWrapperMounted="onTreeListEditWrapperMounted"
    />
</template>
<script>
export default {
    name: 'is-spr-direct-view',
};
</script>
<script setup>
import { onMounted, ref } from 'vue';
import { DxCheckBox } from 'devextreme-vue/check-box';
import { meta } from './meta';
import aiTreeListEditWrapper from '@/components/wrappers/ai-tree-list-edit-wrapper.vue';
import { setActiveViewInfo, setViewData } from '@/layouts/main-layout/main-layout-data';

const checkboxRef = ref(false);
const showDeleteRef = ref(false);
const treeListRef = ref();
const codeSapMap = {};

const args = {
    select: {
        select_args: {
            selectArg: checkboxRef.value,
            showDeleted: showDeleteRef.value,
        },
    },
};

onMounted(() => {
    treeListRef.value.ref.treeListInstance.on('focusedCellChanged', onFocusedCellChanged);
    treeListRef.value.ref.treeListInstance.on('optionChanged', onOptionChanged);
});

const onFocusedCellChanged = event => {
    if (event.column && event.column.dataField === 'mb3_code') {
        if (!event.row.data.mvp_code) {
            treeListRef.value.ref.treeListInstance.columnOption('mb3_code', 'allowEditing', false);
        } else {
            codeSapMap[event.row.key] = event.row.data.mvp_code;
            treeListRef.value.ref.treeListInstance.columnOption('mb3_code', 'allowEditing', true);
        }
    }
};

const onTreeListEditWrapperMounted = async () => {
    setActiveViewInfo({ refresh: treeListRef.value.ref.setDataSource, userData: () => {}, userSettings: () => {} });

    await setViewData();
};

const onOptionChanged = event => {
    if (event.fullName === 'editing.changes') {
        for (let changeObj of event.value) {
            if (changeObj.type === 'update') {
                const data = changeObj.data;
                const key = changeObj.key;
                const field = Object.hasOwn(data, 'mb3_code');
                if (field) {
                    const str = data.mb3_code.split('');

                    const result = str.map((char, index) => {
                        if (index >= 4 && /[a-zA-Zа-яА-Я]/.test(char)) {
                            return 'X';
                        } else {
                            return char;
                        }
                    });

                    if (codeSapMap[key]) {
                        result.splice(0, 4, ...codeSapMap[key].slice(0, 4));
                    }

                    data.mb3_code = result.join('');
                }
            }
        }
    }
};

const onShowDeleteValueChange = async event => {
    showDeleteRef.value = event.value;
    args.select.select_args.showDeleted = event.value;

    await treeListRef.value.ref.setDataSource(false, args.select);
};

const onValueChange = async event => {
    checkboxRef.value = event.value;
    args.select.select_args.selectArg = event.value;

    await treeListRef.value.ref.setDataSource(false, args.select);
};
</script>
